var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiteAssessment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 204,
    viewBox: "0 0 321 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_822)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_281_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.047 195.34H306.422V121.968L310.734 115.151L315.047 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.506 195.34H293.881V121.968L298.193 115.151L302.506 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.965 195.34H281.34V121.968L285.652 115.151L289.965 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.426 195.34H268.801V121.968L273.113 115.151L277.426 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.884 195.34H256.26V121.968L260.572 115.151L264.884 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.343 195.34H243.719V121.968L248.031 115.151L252.343 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.804 195.34H231.18V121.968L235.492 115.151L239.804 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.263 195.34H218.639V121.968L222.951 115.151L227.263 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.722 195.34H206.098V121.968L210.41 115.151L214.722 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.183 195.34H193.559V121.968L197.871 115.151L202.183 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.642 195.34H181.018V121.968L185.33 115.151L189.642 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.101 195.34H168.477V121.968L172.789 115.151L177.101 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.562 195.34H155.938V121.968L160.25 115.151L164.562 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.021 195.34H143.396V121.968L147.709 115.151L152.021 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.481 195.34H130.855V121.968L135.168 115.151L139.481 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.941 195.34H118.316V121.968L122.629 115.151L126.941 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.4 195.34H105.775V121.968L110.088 115.151L114.4 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.832 195.34H205.207V121.968L209.519 115.151L213.832 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.291 195.34H192.666V121.968L196.978 115.151L201.291 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75 195.34H180.125V121.968L184.438 115.151L188.75 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.211 195.34H167.586V121.968L171.898 115.151L176.211 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.67 195.34H155.045V121.968L159.357 115.151L163.67 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.129 195.34H142.504V121.968L146.816 115.151L151.129 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.59 195.34H129.965V121.968L134.277 115.151L138.59 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.048 195.34H117.424V121.968L121.736 115.151L126.048 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.507 195.34H104.883V121.968L109.195 115.151L113.507 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.968 195.34H92.3438V121.968L96.6563 115.151L100.968 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4274 195.34H79.8027V121.968L84.1153 115.151L88.4274 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8864 195.34H67.2617V121.968L71.5739 115.151L75.8864 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3473 195.34H54.7227V121.968L59.0348 115.151L63.3473 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8063 195.34H42.1816V121.968L46.4942 115.151L50.8063 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2657 195.34H29.6406V121.968L33.9532 115.151L38.2657 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7262 195.34H17.1016V121.968L21.4137 115.151L25.7262 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1852 195.34H4.56055V121.968L8.87309 115.151L13.1852 121.968V195.34Z",
    fill: "#EEEBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.939 188.923H275.961C273.707 185.953 269.756 179.969 272.31 177.414C273.472 176.252 274.751 177.357 275.941 179.335C275.53 175.46 275.941 171.751 278.637 170.67C281.094 169.683 282.19 172.657 282.617 176.642C283.827 174.375 285.418 172.783 287.494 172.905C290.462 173.083 289.743 177.044 288.009 181.432C289.325 180.428 290.706 179.937 292.046 180.375C294.856 181.298 292.232 185.242 288.939 188.923Z",
    fill: "#74644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.233 185.592C248.943 184.935 247.22 182.885 246.535 180.603C245.849 178.321 246.091 175.844 246.76 173.557C247.306 171.69 248.133 169.886 248.337 167.95C249.016 161.51 242.774 154.931 245.71 149.161C246.66 147.295 248.499 145.836 248.827 143.769C249.098 142.058 248.256 140.397 247.838 138.716C247.261 136.403 247.553 133.779 249.053 131.927C250.553 130.076 253.387 129.266 255.453 130.452C258.156 132.003 258.39 135.833 257.696 138.871C257.002 141.91 255.714 145.036 256.563 148.036C257.371 150.894 260.004 153.047 260.476 155.981C260.869 158.418 259.678 160.797 259.156 163.212C258.334 167.006 259.17 170.939 259.207 174.82C259.243 178.702 258.147 183.055 251.233 185.592Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.233 185.592C248.943 184.935 247.22 182.885 246.535 180.603C245.849 178.321 246.091 175.844 246.76 173.557C247.306 171.69 248.133 169.886 248.337 167.95C249.016 161.51 242.774 154.931 245.71 149.161C246.66 147.295 248.499 145.836 248.827 143.769C249.098 142.058 248.256 140.397 247.838 138.716C247.261 136.403 247.553 133.779 249.053 131.927C250.553 130.076 253.387 129.266 255.453 130.452C258.156 132.003 258.39 135.833 257.696 138.871C257.002 141.91 255.714 145.036 256.563 148.036C257.371 150.894 260.004 153.047 260.476 155.981C260.869 158.418 259.678 160.797 259.156 163.212C258.334 167.006 259.17 170.939 259.207 174.82C259.243 178.702 258.147 183.055 251.233 185.592Z",
    fill: "#0E4945"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.158 185.961C243.796 185.528 242.573 184.739 241.616 183.677C240.659 182.615 240.001 181.317 239.711 179.916C239.264 177.607 239.813 175.012 238.549 173.028C236.837 170.339 235.081 170.035 232.949 167.665C229.671 164.021 229.556 162.407 229.772 155.658C229.864 152.803 225.924 149.582 227.312 146.84C228.534 144.423 232.25 144.411 234.357 146.111C236.464 147.811 237.39 150.537 238.308 153.084C239.226 155.632 240.384 158.327 242.711 159.71C244.107 160.539 245.934 160.923 246.705 162.351C247.324 163.499 247.012 164.901 246.764 166.182C246.137 169.402 246.295 173.332 248.997 175.189C250.215 176.029 251.812 176.317 252.814 177.407C253.805 178.483 253.965 180.078 253.898 181.54C253.766 184.351 252.992 187.093 251.635 189.558",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.326 188.203C253.135 186.784 252.417 185.027 252.273 183.179C252.129 181.331 252.565 179.484 253.521 177.896C255.175 175.275 258.257 173.468 258.904 170.439C259.48 167.739 257.882 164.949 258.36 162.232C258.881 159.276 261.609 157.336 263.779 155.261C264.344 154.757 264.829 154.171 265.219 153.522C266.173 151.804 265.907 149.698 266.231 147.76C266.851 144.049 269.907 140.758 273.618 140.144C276.872 139.606 279.203 141.476 279.203 144.921C279.203 149.001 276.148 150.75 274.589 152.597C272.35 155.271 271.162 158.67 271.247 162.157C271.356 166.053 273.014 170.201 271.243 173.671C269.944 176.217 267.167 177.576 264.985 179.424C263.337 180.837 261.995 182.572 261.043 184.523C260.09 186.475 259.546 188.6 259.446 190.77",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M250.576 195.338H205.986C208.723 192.925 216.215 186.689 221.819 185.556C228.8 184.146 236.946 185.214 240.028 186.6C245.565 189.086 249.558 193.997 250.576 195.338Z",
    fill: "#121915"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M301.485 195.338H261.893C264.524 193.295 270.984 188.598 275.853 187.721C282.115 186.596 289.421 187.449 292.186 188.554C296.896 190.435 300.356 194.054 301.485 195.338Z",
    fill: "#121915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1528 138.129H35.6367V183.765H38.1528V138.129Z",
    fill: "#74644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4854 107.333C43.5912 107.333 50.1623 100.759 50.1623 92.6495C50.1623 84.5402 43.5912 77.9664 35.4854 77.9664C27.3796 77.9664 20.8086 84.5402 20.8086 92.6495C20.8086 100.759 27.3796 107.333 35.4854 107.333Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0577 148.283C51.2963 148.283 57.1643 142.412 57.1643 135.17C57.1643 127.929 51.2963 122.058 44.0577 122.058C36.8192 122.058 30.9512 127.929 30.9512 135.17C30.9512 142.412 36.8192 148.283 44.0577 148.283Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4364 149.169C36.1645 149.169 42.4294 142.902 42.4294 135.17C42.4294 127.439 36.1645 121.171 28.4364 121.171C20.7082 121.171 14.4434 127.439 14.4434 135.17C14.4434 142.902 20.7082 149.169 28.4364 149.169Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8765 119.101C52.3732 119.101 57.6398 113.832 57.6398 107.333C57.6398 100.833 52.3732 95.5643 45.8765 95.5643C39.3799 95.5643 34.1133 100.833 34.1133 107.333C34.1133 113.832 39.3799 119.101 45.8765 119.101Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8961 126.17C43.3927 126.17 48.6593 120.902 48.6593 114.402C48.6593 107.903 43.3927 102.634 36.8961 102.634C30.3994 102.634 25.1328 107.903 25.1328 114.402C25.1328 120.902 30.3994 126.17 36.8961 126.17Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9078 130.869C57.4044 130.869 62.671 125.6 62.671 119.101C62.671 112.601 57.4044 107.333 50.9078 107.333C44.4111 107.333 39.1445 112.601 39.1445 119.101C39.1445 125.6 44.4111 130.869 50.9078 130.869Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3492 118.682C28.8459 118.682 34.1124 113.413 34.1124 106.914C34.1124 100.414 28.8459 95.1454 22.3492 95.1454C15.8525 95.1454 10.5859 100.414 10.5859 106.914C10.5859 113.413 15.8525 118.682 22.3492 118.682Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3492 133.283C28.8459 133.283 34.1124 128.015 34.1124 121.515C34.1124 115.016 28.8459 109.747 22.3492 109.747C15.8525 109.747 10.5859 115.016 10.5859 121.515C10.5859 128.015 15.8525 133.283 22.3492 133.283Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3342 183.767H28.6536C24.8625 180.74 24.6013 173.921 28.5318 170.875C31.5607 168.528 36.1392 169.156 38.9858 171.597C38.4539 169.78 38.4433 167.849 38.9554 166.026C39.8812 162.742 41.9388 159.408 45.0806 158.08C53.0978 154.696 58.7955 161.787 59.9362 165.751C61.9885 162.732 66.5808 161.136 69.4627 163.168C73.1138 165.743 72.9485 169.802 70.0361 172.715C73.9166 171.991 76.8391 172.55 79.5306 175.44C81.5785 177.639 81.8924 181.388 80.3342 183.767Z",
    fill: "#0E4945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53 206.964C239.595 206.964 304.5 200.052 304.5 191.526C304.5 183 239.595 176.089 159.53 176.089C79.4657 176.089 14.5605 183 14.5605 191.526C14.5605 200.052 79.4657 206.964 159.53 206.964Z",
    fill: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.704 64.7792H85.6699V177.55H247.704V64.7792Z",
    fill: "#7DB799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.045 133.192V79.8187H162.383V133.192H110.045Z",
    fill: "#E8FFF3",
    stroke: "#7DB799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.883 79.3187H109.545V133.692H162.883V79.3187Z",
    stroke: "#74644B",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.213 79.8248V133.185",
    stroke: "#74644B",
    strokeWidth: 3.827,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.882 106.505H109.545",
    stroke: "#74644B",
    strokeWidth: 3.827,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59 79.3187V161.19H232.23V79.3187H186.59ZM227.747 156.705H188.835V83.8033H227.747V156.705Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.691 81.8625V158.65H188.988V81.8625H229.691Z",
    fill: "#E8FFF3",
    stroke: "#74644B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.285 82.3214L209.285 158.337",
    stroke: "#74644B",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0586 67.6804L166.634 6.23425L251.838 67.4257",
    fill: "#7DB799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.171 68.5477V74.6342C258.171 74.763 258.136 74.8894 258.069 74.9993C258.001 75.1093 257.905 75.1986 257.791 75.2574C257.676 75.3162 257.547 75.3422 257.419 75.3326C257.291 75.323 257.167 75.2781 257.063 75.2029L166.633 10.2594L75.8336 75.456C75.729 75.5312 75.6057 75.576 75.4772 75.5856C75.3488 75.5952 75.2202 75.5692 75.1055 75.5104C74.9909 75.4516 74.8947 75.3623 74.8275 75.2524C74.7603 75.1425 74.7247 75.0161 74.7246 74.8873V68.8C74.7247 68.6146 74.7689 68.4318 74.8536 68.2668C74.9384 68.1018 75.0612 67.9594 75.2119 67.8514L164.729 3.577C165.285 3.17837 165.951 2.96399 166.635 2.96399C167.319 2.96399 167.986 3.17837 168.541 3.577L257.685 67.5983C257.835 67.7066 257.958 67.8491 258.043 68.0142C258.127 68.1793 258.171 68.3622 258.171 68.5477Z",
    fill: "#333939"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_281_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.741 166.691H75.6337C75.1802 166.691 74.8125 166.982 74.8125 167.34V186.925C74.8125 187.284 75.1802 187.574 75.6337 187.574H257.741C258.195 187.574 258.562 187.284 258.562 186.925V167.34C258.562 166.982 258.195 166.691 257.741 166.691Z",
    fill: "#333939"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 193.586V202.775C115.999 202.497 296.899 202.023 296.499 202.357C296.1 202.692 296.333 196.649 296.499 193.586",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9531 201.522L50.9531 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9023 201.522L77.9023 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.854 201.522L104.854 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.803 201.522L131.803 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.752 201.522L158.752 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.705 201.522L185.705 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.654 201.522L212.654 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.604 201.522L239.604 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 201.522L266.555 194.839",
    stroke: "#333939",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7716 190.257C64.2659 190.257 60.6133 186.604 60.6133 182.097V132.441C60.6133 125.171 69.401 121.531 74.5404 126.671L124.19 176.328C129.33 181.468 125.69 190.257 118.422 190.257H68.7716Z",
    fill: "#0E4945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.602 174.74L75.2932 125.425C72.4997 122.637 68.5022 121.833 64.8555 123.351C61.2089 124.86 58.9434 128.248 58.9434 132.197V177.88C58.9434 185.165 64.8698 191.092 72.1545 191.092H117.831C121.777 191.092 125.17 188.826 126.68 185.182C128.189 181.535 127.393 177.531 124.602 174.74ZM124.043 184.086C123.21 186.093 121.144 188.236 117.831 188.236H72.1545C66.4449 188.236 61.7967 183.59 61.7967 177.877V132.197C61.7967 128.884 63.9396 126.815 65.9484 125.985C66.7159 125.668 67.6262 125.46 68.5878 125.46C70.14 125.46 71.8292 125.996 73.2787 127.44L80.7003 134.863L74.537 141.027C73.9806 141.583 73.9806 142.488 74.537 143.044C74.8167 143.324 75.1819 143.461 75.5471 143.461C75.9124 143.461 76.2776 143.321 76.5572 143.044L82.7205 136.88L88.9209 143.081L82.7576 149.245C82.2012 149.802 82.2012 150.706 82.7576 151.263C83.0372 151.543 83.4025 151.68 83.7677 151.68C84.1329 151.68 84.4981 151.54 84.7778 151.263L90.9411 145.099L96.9959 151.154L90.8326 157.318C90.2762 157.875 90.2762 158.78 90.8326 159.336C91.1123 159.616 91.4775 159.753 91.8427 159.753C92.208 159.753 92.5732 159.613 92.8528 159.336L99.0161 153.172L105.068 159.225L98.9048 165.389C98.3484 165.945 98.3484 166.85 98.9048 167.406C99.1844 167.686 99.5497 167.823 99.9149 167.823C100.28 167.823 100.645 167.683 100.925 167.406L107.088 161.242L113.14 167.295L106.977 173.459C106.421 174.016 106.421 174.92 106.977 175.477C107.257 175.756 107.622 175.893 107.987 175.893C108.352 175.893 108.718 175.754 108.997 175.477L115.16 169.313L122.602 176.755C124.945 179.098 124.89 182.077 124.06 184.084L124.043 184.086ZM78.5004 157.244C78.0923 156.836 77.4817 156.719 76.9453 156.936C76.4117 157.156 76.0636 157.678 76.0636 158.255V172.523C76.0636 173.311 76.7027 173.95 77.4903 173.95H91.7571C92.3335 173.95 92.8557 173.602 93.0754 173.068C93.2979 172.535 93.1752 171.921 92.7672 171.513L78.5004 157.244ZM78.917 171.096V161.699L88.3131 171.096H78.917Z",
    fill: "#D2F0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.399 191.574H291.092",
    stroke: "#333939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.245 197.422L291.092 191.574L285.245 185.727",
    stroke: "#333939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.283 191.574H30.5898",
    stroke: "#333939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4364 197.422L30.5898 191.574L36.4364 185.727",
    stroke: "#333939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_281_822",
    x: 70.8125,
    y: 166.691,
    width: 191.75,
    height: 28.8835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_281_822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_281_822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 202.054,
    fill: "white",
    transform: "translate(0.5 0.972778)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_281_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 209,
    fill: "white",
    transform: "translate(4.5 -2.02234)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteAssessment);
export default __webpack_public_path__ + "static/media/site-assessment.68b7cd38859af8acad4f6ac16fbb8bb4.svg";
export { ForwardRef as ReactComponent };